import roundHalfDown from './roundHalfDown';

export default x => roundHalfDown(x).toFixed(2);



// WEBPACK FOOTER //
// /src/js/common/utils/formatReturns.js